export default __webpack_public_path__ + "static/media/legal-team-defendant.64e7bfb1.png";